const TOKEN_KEY = "jwt-token";
const REFRESH_KEY = "jwt-refresh-token";
const EXPIRES_KEY = "jwt-expires";
const USERID_KEY = "user-local-id";
const GROUP_KEY = "group-local-id";
const COUNTRY_KEY = "userCountry";

export function setTokens({
  refreshToken,
  accessToken,
  userId,
  groupId,
  expiresIn = 3600,
}) {
  const expiresDate = new Date().getTime() + expiresIn * 1000;
  localStorage.setItem(USERID_KEY, userId);
  localStorage.setItem(TOKEN_KEY, accessToken);
  localStorage.setItem(REFRESH_KEY, refreshToken);
  localStorage.setItem(EXPIRES_KEY, expiresDate);
  groupId !== "" && localStorage.setItem(GROUP_KEY, groupId);
}

export function setCountry(country) {
  localStorage.setItem(COUNTRY_KEY, country);
}

export function getCountry() {
  return localStorage.getItem(COUNTRY_KEY);
}

export function getAccessToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function getRefreshToken() {
  return localStorage.getItem(REFRESH_KEY);
}
export function getTokenExpiresDate() {
  return localStorage.getItem(EXPIRES_KEY);
}
export function getUserId() {
  return localStorage.getItem(USERID_KEY);
}
export function getGroupId() {
  return localStorage.getItem(GROUP_KEY);
}
export function removeAuthData() {
  localStorage.removeItem(USERID_KEY);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(EXPIRES_KEY);
  localStorage.removeItem(GROUP_KEY);
  localStorage.removeItem(COUNTRY_KEY);
}

export function removeGroupData() {
  localStorage.removeItem(GROUP_KEY);
}
export function removeCountry() {
  localStorage.removeItem(COUNTRY_KEY);
}

const localStorageService = {
  setTokens,
  getAccessToken,
  getRefreshToken,
  getTokenExpiresDate,
  getUserId,
  getGroupId,
  getCountry,
  setCountry,
  removeAuthData,
  removeCountry,
};

export default localStorageService;
